import async from 'async';
import utils from '@/utils';

const search = (options, commit, callback) => {
  utils.send({
    path: '/products/search',
    options: {
      page: options.page,
      limit: options.limit,
      sortBy: options.sortBy,
      sortDesc: options.sortDesc,
      conditions: options.conditions,
    },
    callback(data) {
      commit('search', data);
      callback(null);
    },
  });
};

const find = (id, commit, callback) => {
  utils.send({
    path: '/products/find',
    params: [id],
    callback(data) {
      commit('loadForm', data.item);
      callback(null);
    },
  });
};

const info = (id, commit, callback) => {
  utils.send({
    path: '/products/find',
    params: [id],
    callback(data) {
      commit('loadInfo', data.item);
      callback(null);
    },
  });
};

export default {
  searchList: ({ state, commit }, { page, limit, sortBy, sortDesc, conditions }) => {
    search({
      page: page,
      limit: limit,
      sortBy: sortBy,
      sortDesc: sortDesc,
      conditions: conditions,
    }, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  addItem: ({ state, commit }, { form, callback }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/products/add', 
          options: {
            type: form.type,
            maker: form.maker,
            name: form.name,
            cas_no: form.cas_no,
            fema_no: form.fema_no,
            pieces: form.pieces,
            nums: form.nums,
            synonym: form.synonym,
          },
          callback(data) {
            utils.success('productsAdd');
            callback(data);
            next(null, data.id);
          },
        });
      },
      (id, next) => { find(id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  updateItem: ({ state, commit }, { form, callback }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/products/update',
          params: [form.id],
          options: {
            type: form.type,
            maker: form.maker,
            name: form.name,
            cas_no: form.cas_no,
            fema_no: form.fema_no,
            pieces: form.pieces,
            nums: form.nums,
            synonym: form.synonym,
          },
          callback(data) {
            utils.success('productsUpdate');
            callback(data);
            next(null);
          },
        });
      },
      (next) => { find(form.id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  deleteItem: ({ state, commit }, id) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/products/delete',
          params: [id],
          callback(data) {
            utils.success('productsDelete');
            next(null);
          },
        });
      },
      (next) => { search(state, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  changePublic: ({ state, commit }, id) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/products/public',
          params: [id],
          callback(data) {
            utils.success('productsPublic');
            next(null);
          },
        });
      },
      (next) => { find(id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  statusChange: ({ state, commit }, { id, status }) => {
    async.waterfall([
      (next) => {
        utils.send({
          path: '/products/status',
          params: [id],
          options: {
            status: status,
          },
          callback(data) {
            const code = {
              public: 'productsPublic',
              finish: 'productsFinish',
              cancel: 'productsCancel',
            };
            utils.success(code[status]);
            next(null);
          },
        });
      },
      (next) => { find(id, commit, next); },
    ], (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  loadInfo: ({ state, commit }, id) => {
    info(id, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    });
  },

  loadForm: ({ state, commit }, id) => {
    find(id, commit, (err) => {
      if (err) {
        utils.error('illegal');
      }
    })
  },

  clearForm: ({ state, commit }) => {
    commit('clearForm');
  },

  sendInquiry: ({ state, commit }, { id, email, subject, content }) => {
    utils.send({
      path: '/products/inquiry',
      params: [id],
      options: {
        email: email,
        subject: subject,
        content: content,
      },
      callback(data) {
        utils.success('productsInquiry');
      },
    });
  },

  uploads: ({ state, commit }, productId) => {
    utils.send({
      path: '/uploads/list',
      params: [productId],
      callback(data) {
        commit('uploads', data.list);
      },
    });
  },
};
